export enum EApprovalType {
    Approval = 1,
    AdmissionApproval = 2,
}
